import * as React from 'react';
import { useNavigate } from 'react-router-dom';

import { useModal } from 'mui-modal-provider';

import OfferSuccessDialog from '../../components/Dialogs/OfferSuccess/OfferSuccessDialog';
import { BackdropLoading } from '../../contexts/Backgrop/Backdrop';
import { OfferCategory } from '../../graphql/API';
import { useCreateOfferQuery } from '../../hooks/reactQuery/useOfferQuery';
import useQueryParams from '../../hooks/useQueryParams';
import { useAppSelector } from '../../redux/hooks';
import { VENUE_MANUAL_TAGS } from '../../utils/venue-tags';
import { extractSubscriptionPlan } from '../SubscriptionPlans/common/helper';
import OfferForm from './OfferForm';
import { FormValue, initialValues, mapToCreateOfferInput } from './components/schema';

const CreateOffer: React.FC = () => {
  const navigate = useNavigate();
  const { getQueryParam } = useQueryParams();
  const offerType = getQueryParam('type');
  const venueState = useAppSelector((state) => state.venue.value);

  const { subscription } = useAppSelector((state) => state.subscription.value);

  const subscriptionPlan = React.useMemo(() => {
    const [plan] = extractSubscriptionPlan(subscription?.sku ?? '');

    return plan;
  }, [subscription]);

  React.useEffect(() => {
    if (venueState?.tags?.includes(VENUE_MANUAL_TAGS.Online)) {
      navigate('/products/create');
    }
  }, [navigate, venueState]);

  const { showModal } = useModal();

  const values: FormValue = {
    ...initialValues,
    ...(offerType === 'collab' ? { category: OfferCategory.unknown, type: 'private' } : {}),
  };

  const mutation = useCreateOfferQuery('/offers?status=pending', () => {
    window.localStorage.setItem('offer-form-data', JSON.stringify(values));
    window.localStorage.setItem('offer-form-step', JSON.stringify(0));
  });

  return (
    <>
      <OfferForm
        method='insert'
        formConfig={{
          initialValues: {
            ...values,
          },
          onSubmit: async (values: FormValue) => {
            if (venueState) {
              const input = mapToCreateOfferInput(
                venueState.id,
                values,
                values?.category === OfferCategory.event && values?.offerTimeZoneId ? values?.offerTimeZoneId : venueState.timeZoneId,
                subscriptionPlan,
              );

              await mutation.mutateAsync(input);

              showModal(OfferSuccessDialog, {});
            }
          },
        }}
        offerTypeIndex={offerType === 'collab' ? 1 : -1}
      />
      {mutation.isPending && <BackdropLoading open />}
    </>
  );
};

export default CreateOffer;
